import { createContext, useState, useMemo, type ReactNode } from "react";

export const PaymentContext = createContext<any>(null);

export const PaymentProvider = ({ children }: { children: ReactNode }) => {
  const [selectedPaymentType, setSelectedPaymentType] = useState();
  const [successInfo, setSuccessInfo] = useState();
  const [accountBal, setAccountBal] = useState<string>();
  const [getBalDate, setGetBalDate] = useState<string>();

  const contextValue = useMemo(
    () => ({
      selectedPaymentType,
      successInfo,
      accountBal,
      getBalDate,
      setSelectedPaymentType,
      setSuccessInfo,
      setAccountBal,
      setGetBalDate,
    }),
    [selectedPaymentType, successInfo, accountBal, getBalDate]
  );

  return (
    <PaymentContext.Provider value={contextValue}>
      {children}
    </PaymentContext.Provider>
  );
};
